import React, { useState } from "react";
import { Badge, Modal, Box, Typography } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import moment from "moment";
import DownloadIcon from "@mui/icons-material/Download";
import apiUrl from "../../../providers/apiUrl";

import styled from "styled-components";

const ClampedText = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffffff;
  border-top: 2px solid #ffffff;
  width: 100%;
  text-align: left;
`;

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

function AnnouncementCard({ additionalInfo, contract, data }) {
  const [showFiles, setShowFiles] = useState(false);
  let date = moment(data?.end_date);
  let finished_date_day = date.format("DD");
  let finished_date_rest = date.format("MMMM YYYY");

  const handleDownload = (doc) => {
    const baseDomain = apiUrl.replace(/\/api$/, "");

    const fullUrl = doc.document_url.startsWith("http")
      ? doc.document_url
      : `${baseDomain}/${doc.document_url}`;

    const link = document.createElement("a");
    link.href = fullUrl;
    link.target = "_blank";
    link.setAttribute("download", doc.name || "documento.pdf");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="h-full bg-[#2F5D42] rounded p-5 box-border flex flex-col justify-between w-full mx-auto">
      <div className="flex flex-col items-start gap-2 w-full">
        <div className="flex items-center justify-between w-full">
          <h3 className="text-[#FFFFFF] text-xl">{data?.name}</h3>

          {data?.documents?.length > 0 && (
            <div className="flex items-center justify-center">
              <Badge
                badgeContent={`${data.documents.length}`}
                overlap="circular"
                sx={{
                  color: "white",
                  "& .MuiBadge-badge": {
                    fontSize: "0.75rem",
                    backgroundColor: "#172726",
                  }
                }}
              >
                <div
                  onClick={() => {
                    if (data.documents.length === 1) {
                      handleDownload(data.documents[0]);
                    } else {
                      setShowFiles(true);
                    }
                  }}
                  className="cursor-pointer flex items-center justify-center"
                >
                  <InsertDriveFileIcon sx={{ color: "white" }} />
                </div>
              </Badge>
            </div>
          )}
        </div>
        <ClampedText>{data?.title}</ClampedText>
      </div>
      {data?.external_url && (
        <div className="mt-4">
          <a
            href={data?.external_url}
            target="_blank"
            rel="noopener noreferrer"
            className="underline font-semibold text-md mt-5 text-white"
          >
            Link para os documentos externos <KeyboardArrowRightOutlinedIcon />
          </a>
        </div>
      )}
      <p className="text-lg text-[#363950] text-left">{additionalInfo}</p>
      {contract && (
        <div className="flex flex-col md:flex-row justify-between mt-3">
          <div className="flex flex-col">
            <div className="flex">
              <p className="text-[#FFFFFF]">
                <span className="text-2xl whitespace-nowrap">
                  {finished_date_day + " " + finished_date_rest}
                </span>
              </p>
            </div>
            <p className="text-[#FFFFFF] text-left">
              {data?.country} , {data?.district}
            </p>
          </div>
        </div>
      )}

      <Modal open={showFiles} onClose={() => setShowFiles(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" mb={2}>
            Documentos
          </Typography>

          <div className="flex flex-col gap-2">
            {data?.documents?.map((doc, index) => (
              <div
                key={doc.id ?? index}
                onClick={() => handleDownload(doc)}
                className="flex items-center justify-between cursor-pointer hover:bg-gray-100 p-2 rounded"
              >
                <span className="truncate">
                  {doc.name || `Document ${index + 1}`}
                </span>
                <DownloadIcon />
              </div>
            ))}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default AnnouncementCard;
